var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.900391,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 15.5,
    stroke: "#E6E6E6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1133_1158)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.4001 18.6667H22.4001C22.7683 18.6667 23.0667 18.3682 23.0667 18V14C23.0667 13.6318 22.7683 13.3333 22.4001 13.3333H10.4001C10.0319 13.3333 9.7334 13.6318 9.7334 14V18C9.7334 18.3682 10.0319 18.6667 10.4001 18.6667H12.4001M12.4001 16H20.4001V21.3333C20.4001 21.7015 20.1016 22 19.7334 22H13.0667C12.6985 22 12.4001 21.7015 12.4001 21.3333V16ZM20.4001 13.3333V10.6667C20.4001 10.2985 20.1016 10 19.7334 10H13.0667C12.6985 10 12.4001 10.2985 12.4001 10.6667V13.3333H20.4001Z",
    stroke: "#4C4C4C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1133_1158"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(8.40039 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrint);
export default __webpack_public_path__ + "static/media/print.aa8d7845753095038edb6cc50222fb64.svg";
export { ForwardRef as ReactComponent };